import styled from "styled-components";
import { Table as _Table } from "_/components/table";
import { Icon as _Icon } from "_/components/icon";
import { Alert } from "_/components/alert";

export const NoMachinesContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  background-color: ${(p) => p.theme.background.secondary};
  border-radius: 5px;
  color: ${(p) => p.theme.text.muted};
`;

export const DetachedSerialNumber = styled.span`
  margin-right: 0.25rem;
`;

export const DetachedSerialNumberLabel = styled.span`
  color: ${(p) => p.theme.text.muted};
`;

export const DetachedSerialNumberContainer = styled.span`
  line-height: 1rem;
`;

export const LastSeenCell = styled.div`
  display: flex;
  align-items: center;
`;

export const LastSeenDot = styled(_Icon)<{ $color: string }>`
  margin-right: 0.625em;
  color: ${(p) => {
    switch (p.$color) {
      case "grey":
        return p.theme.color.palette.ironGrey;
      case "red":
        return p.theme.color.palette.tomatoRed;
      case "orange":
        return p.theme.color.palette.sunsetOrange;
      case "green":
        return p.theme.color.palette.forestGreen;
      default:
        return p.theme.color.palette.ironGrey;
    }
  }};
`;

export const VersionWrapper = styled.div`
  margin-top: 4px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  & div {
    display: flex;
    gap: 0.25rem;
    &.pending {
      color: ${(p) => p.theme.text.muted};
    }
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const PinnedChannel = styled.span`
  text-decoration: line-through double;
`;

export const DetachedAlert = styled(Alert)`
  margin-bottom: 0;
`;
